// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2xGWF","fileBtn":"File_fileBtn__2D17t","closeBtn":"File_closeBtn__yTCEN","fileSelected":"File_fileSelected__1NT2Q","disabled":"File_disabled__2S7pC"};